import './result.css';
import React, {Component } from 'react';
import {
    List, Grid, ListItem, Tooltip, TablePagination, Typography, Checkbox, FormControlLabel, Button,
    ListItemText, ListItemAvatar, TextField, Avatar, Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Alert, Chip, Autocomplete, ToggleButton, ToggleButtonGroup, Dialog, DialogActions, DialogTitle, DialogContent,
    Stack,
} from '@mui/material';
import filter from '../../service/filter'
import SearchIcon from '@mui/icons-material/Search';
import Filters from './filter';
import FileDownloadIcon from '@mui/icons-material/Merge'
import IconButton from '@mui/material/IconButton';
import moment, { min } from 'moment';
import HomeIcon from '@mui/icons-material/Home';
import CONSTANT from '../../Constant/Constant';
import { Link } from "react-router-dom";
import ViewListIcon from '@mui/icons-material/ViewList';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import Close from '@mui/icons-material/Close';
import Merge from '@mui/icons-material/Merge';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Storage from '../../session/storage'
import vendorInfo from '../../config/MergeSourceScope.json';
import AddIcon from '@mui/icons-material/Add';
import popUpMessage from '../../config/popUpMsg.json';
import ClearIcon from '@mui/icons-material/Clear';
import ProfileIcon from '../shared/ProfileIcon';
import { DirectionContext } from '../../context/DirectionProvider';
import { sortTranslated } from '../shared/util';



class Result extends Component {
    constructor(props) {
        super(props);

        let hcpFormValue = (this.props.form && this.props.form?.entity) ? this.props.form?.entity : undefined;
        let isEmployer = this.props.isEmployer;
        this.state = {
            page: 0,
            isEmployer: isEmployer,
            HCP: (hcpFormValue ? ((hcpFormValue.length === 2 || hcpFormValue.length === 0) ? true : hcpFormValue[0].name === 'HCP') :
                (this.props.entityTabs === 'HCP')) || false,
            HCO: (hcpFormValue ? ((hcpFormValue.length === 0 || hcpFormValue.length === 2) ? true : hcpFormValue[0].name === 'HCO') :
                (this.props.entityTabs === 'HCO')) || false,
            rowsPerPage: 10,
            allItems: this.props.result,
            sessionAllItems: this.props.result,
            defaultAllItems: this.props.result,
            rowsArray: [],
            dynamicFilterList: new Map(),
            appliedFilter: {},
            detailViewFlag: false,
            recordId: '',
            entity: '',
            view: 'list',
            dynamicList: [],
            lillySelectedCountry: [],
            showVendorPopUp: false,
            showCheckBox: false,
            selectedList: [],
            popUpMessage:{},
            showWarningPopUp: false,
            checklist: [],         
            popUpMsg: { heading: "", description: "" },
            mergeScopeSources: vendorInfo.mergeScopeSources,
            excludeLillySource: vendorInfo.excludeVendorSources,
            sourceData: vendorInfo.vendorChipData,
            popUpMsgData: popUpMessage.searchResult,
            openDataSources: vendorInfo.openDataSources,
            userData: Storage.getUserData()





        };

        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.getRowArray = this.getRowArray.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.goToDetails = this.goToDetails.bind(this);
        this.getAllDetails = this.getAllDetails.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
        this.state.dynamicFilterList = filter.formFilterData(JSON.parse(JSON.stringify(this.props.result)));
        this.state.rowsArray = this.getRowArray(this.props.result);
        this.state.allItems = this.props.result.slice(0, this.state.rowsPerPage);


    }



    componentDidUpdate(prevProps) {
        if (this.props.result !== prevProps.result) {
            this.setState((prevState) => {
                const dynamicFilterList = filter.formFilterData(JSON.parse(JSON.stringify(this.props.result)));
                const page = 0;
                const rowsPerPage = 10;
                const allItems = this.props.result.slice(0, rowsPerPage);
                const rowsArray = this.getRowArray(this.props.result);
                return {
                    dynamicFilterList,
                    page,
                    rowsPerPage,
                    allItems,
                    rowsArray,
                }
            //codeql
            // this.setState({
            //     dynamicFilterList: new Map()
            // });
            // this.setState({
            //     dynamicFilterList: filter.formFilterData(JSON.parse(JSON.stringify(this.props.result)))
            // })
            // this.setState({
            //     page: 0,
            //     rowsPerPage: 10,
            //     allItems: this.props.result.slice(0, this.state.rowsPerPage),
            //     rowsArray: this.getRowArray(this.props.result)
            });
        }

    }



    /**
     * Initial Set All Rows Info
     * @param {*} allItems 
     * @returns 
     */
    getRowArray(allItems) {
        let counter = 10;
        this.state.rowsArray.splice(0, this.state.rowsArray.length);
        (allItems.length / 2 < counter) && this.state.rowsArray.push(allItems.length)
        while ((allItems.length / 2) > counter) {
            this.state.rowsArray.push(counter)
            counter += 10;
        }
        return this.state.rowsArray;
    }

    /**
     * Row Change
     * @param {*} event 
     * @param {*} sessionItems 
     */
    handleChangeRowsPerPage(event, sessionItems) {
        this.setState({
            rowsPerPage: event.target.value,
            allItems: sessionItems.slice(0, event.target.value),
        })
    }

    /**
     * Page Change
     * @param {*} event 
     * @param {*} newPage 
     * @param {*} sessionItems 
     */
    handleChangePage(event, newPage, sessionItems) {
        let startIndex = (newPage) * this.state.rowsPerPage;
        let endIndex = startIndex + this.state.rowsPerPage;
        if (endIndex > sessionItems.length) {
            endIndex = sessionItems.length;
        }
        this.setState((prevState)=>({
            allItems: sessionItems.slice(startIndex, endIndex),
            page: newPage,
            rowsPerPage: prevState.rowsPerPage,
        }))
    }

    /**
     * On Select of options 
     * @param {*} filterValue 
     * @param {*} name 
     */
    async onSelect(filterValue, name) {

        await this.setState((prevState) => {
            return (
                {
                    ...prevState,
                    appliedFilter: {
                        ...this.state.appliedFilter,
                        [name]: []
                    }
                }
            )
        });

        if (filterValue.length === 0) {

            await this.setState((prevState) => {
                return (
                    {
                        ...prevState,
                        appliedFilter: {
                            ...this.state.appliedFilter,
                            [name]: undefined
                        }
                    }
                )
            });
        } else {

            filterValue.forEach(async (filterItem) => {
                if (this.state.appliedFilter[name] === undefined) {
                    await this.setState((prevState) => {
                        return (
                            {
                                ...prevState,
                                appliedFilter: {
                                    ...this.state.appliedFilter,
                                    [name]: [filterItem]
                                }
                            }
                        )
                    });

                } else {
                    if (!this.state.appliedFilter[name].includes(filterItem)) {
                        this.state.appliedFilter[name].push(filterItem);
                    }

                }
            })
        }

        this.filterHCPHCO(undefined);
    }

    /**
     * Recursive logic to check exist
     * @param {*} detail 
     * @param {*} name 
     * @param {*} i 
     * @param {*} filter 
     * @returns 
     */
    checkExist(detail, name, i, filter) {

        if (name.length === 1 || i === (name.length - 1)) {
            if (detail[name[i]] !== undefined) {
                let exist = false;
                detail[name[i]].forEach(res => {
                    exist = exist || this.state.appliedFilter[filter]?.includes(res.value);
                })
                return exist;
            } else {
                return false;
            }
        } else if (name.length > 1 && i !== (name.length - 1)) {

            if (detail[name[i]] !== undefined) {
                let exist = false;
                detail[name[i]].forEach(res => {
                    exist = exist || this.checkExist(res, name, i + 1, filter);
                })
                return exist;
            } else {
                return false;
            }
        }
        return false;


    }
    // pop up open for vendor
    openPopUp() {

        this.setState({ showVendorPopUp: true })

    }

    /**
     * Aplly filter
     * @returns fltered list
     */
    applyFilter() {
        if (this.state.appliedFilter === undefined) {
            return this.state.defaultAllItems;
        } else {
            try {
                Object.keys(this.state.appliedFilter).forEach(key => this.state.appliedFilter[key] === undefined ? delete this.state.appliedFilter[key] : {});
                let allDetails = this.state.defaultAllItems;
                let filterName = Object.keys(this.state.appliedFilter);
                let filteredItems = [];
                let count = 0;

                filterName?.forEach((name) => {
                    if (this.state.appliedFilter[name] === undefined) {
                        count++;
                    }
                });

                if (filterName.length === count) {
                    filteredItems = this.props.result;
                } else {
                    allDetails?.forEach((item, i) => {
                        let firstTime = true;
                        let insertRecord = false;

                        filterName?.forEach((name) => {
                            let itemPresent = false;
                            if (this.state.appliedFilter[name] !== undefined) {
                                let filterNameValue = JSON.parse(JSON.stringify(name));
                                itemPresent = this.checkExist(item._source, name.split('.'), 0, filterNameValue)
                                if (itemPresent) {
                                    if (firstTime) {
                                        insertRecord = firstTime && itemPresent;
                                        firstTime = false;
                                    } else {
                                        insertRecord = insertRecord && itemPresent;
                                    }
                                } else {
                                    if (firstTime) {
                                        firstTime = false;
                                    }
                                    insertRecord = false;
                                }
                            } else {
                                insertRecord = false;
                            }
                        });
                        if (insertRecord) {
                            filteredItems.push(item);
                        }
                    });
                }
                return filteredItems;
            } catch (error) {
            }
        }

    }

    /**
     * get Parent name of nested attribute
     * @param {*} record 
     * @param {*} filterName 
     * @returns 
     */
    getParentattribute(record, filterName) {
        let names = Object.keys(record);
        let parentKey;
        for (let name of names) {
            let parentData = record[name];
            if (parentData[filterName] !== undefined) {
                parentKey = name;
                break;
            }
        }
        return parentKey;
    }

    /**
     * show Advance search
     */
    showAdvanceSearch() {
        this.props.showAdvanceSearch();
    }

    vendorSearch(data) {
        this.props.vendorSearch(data);
    }

    /**
     * Get Back 
     */
    getBack() {
        this.props.goToHome();
    }


    // go to merge page
    goToMerge() {

        if (this.state.selectedList.length <= vendorInfo.noOfprofile && this.state.selectedList.length > 1) {

            this.props.history.push({
                pathname: '/merge',
                state: { mergeData: this.state.selectedList }


            })

        }
        else {
            this.state.selectedList.splice(0, this.state.selectedList.length)

            this.setState({
                showWarningPopUp: true,

                popUpMsg: { heading: "Warning", description: `Please select maximum ${vendorInfo.noOfprofile} profile for merge.` }

            })
        }
    }

    /** 
     * cancel merge
    */

    cancelMerge() {
        this.state.selectedList.splice(0, this.state.selectedList.length)
        this.setState({
            showCheckBox: false,
            checklist: []
        })

    }
    /**
     * set details on state
     * @param {*} Details 
     */
    setDeatilsList(Details) {
        let filteredApplied = Details;
        let sessionAppliedFilter = filteredApplied;

        this.setState(prevState => {
            return {
                ...prevState,
                page: 0,
                allItems: [],
                sessionAllItems: [],
                rowsArray: []
            }
        })

        this.setState(prevState => {
            return {
                ...prevState,
                page: 0,
                allItems: filteredApplied.slice(0, this.state.rowsPerPage),
                sessionAllItems: sessionAppliedFilter,
                rowsArray: this.getRowArray(sessionAppliedFilter)
            }
        });
    }
    /***
     * filter HCP & HCO  checkbox
     */
    async filterHCPHCO(event) {

        let allDetails = this.applyFilter();
        let filteredDetails = [];
        if (event !== undefined) {
            await this.setState({
                [event.target.name]: event.target.checked
            });
        }
        let values = [];
        this.state.HCP && values.push("HCP");
        this.state.HCO && values.push("HCO");
        if ((this.state.HCP === true && this.state.HCO === true)) {
            this.setDeatilsList(allDetails);
        } else {
            if (values.length > 0) {
                allDetails.forEach(detail => {
                    if (values.includes(detail._source?.type?.split('/')[2])) {
                        filteredDetails.push(detail);
                    }
                });
                this.setDeatilsList(filteredDetails);

            } else {
                this.setDeatilsList(allDetails);
            }
        }
    }

    /**
     * scroll to top
     */
    async goToDetails() {

    }

    /**
     * go to result page
     */
    getAllDetails() {
        this.setState({ detailViewFlag: false });
    }

    /**
     * view Change
     * @param {*} event 
     * @param {*} nextView 
     */
    handelViewChange(event, nextView) {
        if (nextView !== null) {
            this.setState((oldState) => {
                return {
                    ...oldState,
                    view: nextView
                };
            });
        }
    }

    /**
     * Table Heading Mapping
     * @returns mapped hadding
     */
    getTableRows() {
        const columns = [
            { id: 'label', label: 'Name', minWidth: 170 },
            { id: 'ReferenceId', label: 'Lilly Enterprise ID', minWidth: 170 },
            { id: 'ActiveFlag', label: 'Active Flag', minWidth: 80 },
            {
                id: 'Specialities',
                label: 'Specialities',
                minWidth: 170,
                align: 'right',
                format: (value) => value.toLocaleString('en-US'),
            },
            { id: 'CountryCode', label: 'Country Code', minWidth: 170 },
            { id: 'Source', label: 'Source', minWidth: 170 },
            { id: 'type', label: 'Type', minWidth: 100 },
            {
                id: 'secondaryLabel',
                label: 'Address',
                minWidth: 170,
                align: 'right',
                format: (value) => value.toLocaleString('en-US'),
            },
            { id: 'ClassificationCode', label: 'Classification Code', minWidth: 100 },
            { id: 'SubClassificationCode', label: 'Sub Classification Code', minWidth: 100 },
            { id: 'CustomerTypeCode', label: 'Customer Type Code', minWidth: 100 },
        ];
        return columns;
    }

    /**
     * Add Dynamic filter
     * @param {*} value 
     */
    async addDynamicFilter(value) {
        await this.setState(oldState => {
            return {
                ...oldState,
                dynamicList: value
            }
        })
        if (value.length === 0) {
            this.resetFilter();
        }

    }

    /**
     * Remove dynamic filterF
     * @param {*} name 
     */
    removeDynamicFilter(name) {
        this.setState((oldState) => {
            return {
                ...oldState,
                dynamicList: oldState.dynamicList.filter(filter => filter.id !== name)
            }
        })
    }

    /**
     * Reset filter
     */
    resetFilter() {
        Object.keys(this.state.appliedFilter).forEach((filter) => {
            this.setState((oldState) => {
                return {
                    ...oldState,
                    appliedFilter: undefined
                }
            })
        })
        this.filterHCPHCO(undefined);
    }

    /**
     *  id to name
     * @param {*} id 
     * @returns name
     */
    getLabelDynamicFilter(id) {
        switch (id) {
            case 'primary_HCPReferenceId':
                return 'HCP Enterprise Id';
            case 'primary_HCOReferenceId':
                return 'HCO Enterprise Id';
            case "Address.Zip.Zip5":
                return "Zip/ Postal Code";
            case "Address.SubAdministrativeArea":
                return "SubAdministrativeArea";
            case "Address.Country":
                return "Country";
            case "Address.City":
                return "City";
            case "Address.StateProvince":
                return "StateProvince";
            case "Specialities.Specialty":
                return "Other Specialities"
            default:
                return id;
        }

    }

    // get data after checbox select
    getSelectedData(data, e, key) {
        e.preventDefault();

        var prevCheckList = this.state.checklist
        if (e.target.checked) {

            this.setState({
                checklist: [...prevCheckList, key]
            })
            this.state.selectedList.push(data)


        }
        else if (!e.target.checked) {
            let indexOfItem = this.state.selectedList.findIndex((arr) => arr._id === data._id)
            this.state.selectedList.splice(indexOfItem, 1)
            let keyOfItem = this.state.checklist.findIndex((i) => i == key)
            this.state.checklist.splice(keyOfItem, 1)

            this.setState({
                checklist: [...prevCheckList]
            })

        }
        //const matchArray = this.state.selectedList.filter((e)=> this.state.source.includes(e._source.Source[0].value))
        const matchArray = this.state.selectedList.every((e) => e._source.Source.every((arr) => this.state.mergeScopeSources.includes(arr.value)))
        let matchSameSource = true
        const matchArrayOfSelected = this.state.selectedList.filter((e) => e._source.Source.every((arr) => this.state.excludeLillySource.includes(arr.value)))
        let multiCountryProfile = this.state.selectedList.some((res) => res._source.CountryCode.length > 1)
        if (multiCountryProfile) {
            this.state.selectedList.splice(0, this.state.selectedList.length)
            this.setState({
                showWarningPopUp: true,
                popUpMsg: { heading: this.state.popUpMsgData[0].multiCountryProfile.heading, description: this.state.popUpMsgData[0].multiCountryProfile.description }


            })
        }
        if (matchArrayOfSelected.length > 1) {
            for (let i = 0; i < matchArrayOfSelected.length - 1; i++) {
                for (let j = 1; j < matchArrayOfSelected.length; j++) {
                    if (matchArrayOfSelected[i]?._source?.Source[0]?.value === matchArrayOfSelected[j]?._source?.Source[0]?.value) {

                        matchSameSource = true
                    }
                    else {
                        matchSameSource = false
                    }
                }
            }
        }
        const renderHTML = (html) => ({ __html: html });

        for (let i = 0; i < this.state.selectedList.length - 1; i++) {
            for (let j = 1; j < this.state.selectedList.length; j++) {

                if (this.state.selectedList[i]?._source?.type?.split('/')[2] === this.state.selectedList[j]?._source?.type?.split('/')[2]) {
                    if (matchArray && matchSameSource) {
                        if (this.state.selectedList[i]?._source?.CountryCode[0]?.value.toLowerCase() === this.state.selectedList[j]?._source?.CountryCode[0]?.value.toLowerCase()  && !(this.state.selectedList[i]?._source?.ActiveFlag[0]?.value === 'N' && this.state.selectedList[j]?._source?.ActiveFlag[0]?.value === 'N')) {
                            if (this.state.selectedList.length <= vendorInfo.noOfprofile) {
                            }                                
                            else {
                                this.state.selectedList.splice(0, this.state.selectedList.length)
                                this.setState((prevState)=>({
                                    showWarningPopUp: true,
                                    popUpMsg: { heading: prevState.popUpMsgData[0].maxProfile.heading, description: prevState.popUpMsgData[0].maxProfile.description }
                                }))
                            }
                        }
                        else if(this.state.selectedList[i]?._source?.ActiveFlag[0]?.value === 'N' && this.state.selectedList[j]?._source?.ActiveFlag[0]?.value === 'N'){ 
                            this.state.selectedList.splice(0, this.state.selectedList.length)
                            this.setState((prevState)=>({
                                showWarningPopUp: true,
                                popUpMsg: { heading: prevState.popUpMsgData[0].inactiveProfile.heading, description: prevState.popUpMsgData[0].inactiveProfile.description }
                            }))
                        }
                        else {
                            this.state.selectedList.splice(0, this.state.selectedList.length)
                            this.setState((prevState)=>({
                                showWarningPopUp: true,
                                popUpMsg: { heading: prevState.popUpMsgData[0].wrongCountry.heading, description: prevState.popUpMsgData[0].wrongCountry.description }
                            }))
                        }

                        if(this.state.openDataSources.includes(this.state.selectedList[i]?._source?.Source[0]?.value) && this.state.openDataSources.includes(this.state.selectedList[j]?._source?.Source[0]?.value)){
                            this.state.selectedList.splice(0, this.state.selectedList.length)
                            this.setState((prevState)=>({
                                showWarningPopUp: true,
                                popUpMsg: { heading: prevState.popUpMsgData[0].openDataProfiles.heading, description: prevState.popUpMsgData[0].openDataProfiles.description }
                            })) 
                        }
                    }
                    else {
                        this.state.selectedList.splice(0, this.state.selectedList.length)
                        this.setState((prevState)=>({
                            showWarningPopUp: true,
                            popUpMsg: { heading: prevState.popUpMsgData[0].wrongVendor.heading, description: <div dangerouslySetInnerHTML={renderHTML(prevState.popUpMsgData[0].wrongVendor.description)} /> }
                        }))
                    }
                }
                else {
                    this.state.selectedList.splice(0, this.state.selectedList.length)
                    this.setState((prevState)=>({
                        showWarningPopUp: true,
                        popUpMsg: { heading: prevState.popUpMsgData[0].wrongProfile.heading, description: prevState.popUpMsgData[0].wrongProfile.description }
                    }))
                }
            }
        }
    }

    // Showcheckbox
    showMergedCheckBox() {
        this.setState({
            showCheckBox: true
        })

    }

    // source data to display below profile data
    sourceChipData(source) {


        if (source?.some((e) => vendorInfo.defaultVendorValue.some((arr) => e.value == arr))) {
            let vendor = source?.find((e) => vendorInfo.defaultVendorValue.some((arr) => e.value == arr))
            return (this.state.sourceData[vendor.value])

        }
        else if (source?.length > 1) {
            var sourceValue
            source.forEach(element => {
                sourceValue = this.state.sourceData[element.value]
                if (sourceValue != undefined) {
                    return false;
                }

            });
            return (sourceValue == undefined ? source[0].value : sourceValue);
        }
        else {
            return (this.state.sourceData[source[0]?.value] == undefined ? (source[0]?.value) : (this.state.sourceData[source[0]?.value]))

        }




    }

    //warning popup for wrong step
    handleWarningPopUp() {
        this.setState({
            showWarningPopUp: false,
            checklist: []
        })



    };


    render() {
        let showCheckBox = [];

        let country = '';
        let countCountry = 0;
        let options = [];
        [...this.state.dynamicFilterList].map((filter, key) => {

            options.push({
                id: filter[0], name: filter[0],
                label: (this.getLabelDynamicFilter(filter[0]).includes('.') ? this.getLabelDynamicFilter(filter[0]).split('.').join(' ')
                    : this.getLabelDynamicFilter(filter[0]).includes(' ') ? this.getLabelDynamicFilter(filter[0]) : this.getLabelDynamicFilter(filter[0]).replace(/([a-z])([A-Z])/g, '$1 $2'))
            })
            options = [].concat(options).sort((a, b) => {
                return (a.label < b.label ? -1 : 1)
            });
            return '';
        })
        this.props.form && this.props.form.entity && this.props.form.entity.forEach(entity => {
            showCheckBox.push(entity.name)
        });
        this.props.form && this.props.form.country && this.props.form.country.forEach(entity => {
            if (countCountry === 0) {
                country += entity.name;
            } else {
                country += ', ' + entity.name;
            }
            countCountry++;
        });
        if (this.props.form && this.props.form.entity === undefined && showCheckBox.length === 0 && this.props.entityTabs !== undefined) {
            showCheckBox.push(this.props.entityTabs);
        }

        return (
            <>

                {

                    <div className="container-fluid min-width px-0 row fixed-w">
                        <div className='container row mx-0 bg-grey my-1 pe-0'>
                            <DirectionContext.Consumer>
                                {

                                    (direction)=> {
                                        return (
                                            <div className='col-12'>
                                                <small dir={direction} className="text-dark ml-2 pl-3 _wg-exclude" id="entity">Entity:
                                                    {
                                                        this.props.form && !this.props.entityTabs && showCheckBox.length > 0 && showCheckBox.map((filter, i) => {
                                                            return (<span key={i} className='grey px-1 mx-1' >{filter} </span>)
                                                        })
                                                    }
                                                    {
                                                        this.props.form && !this.props.entityTabs && showCheckBox && showCheckBox.length === 0 &&
                                                        <>
                                                            <Chip label={'HCP'} size="small" className='ml-2 ' />
                                                            <Chip label={'HCO'} size="small" className='ml-2 ' />
                                                        </>

                                                    }
                                                    {
                                                        this.props.entityTabs &&
                                                        (<span className='grey px-1 mx-1' >{this.props.entityTabs} </span>)
                                                    }
                                                </small>

                                                <small dir={direction} className='_wg-exclude' id="search-text" > | Search:
                                                    {this.props.attribute && this.props.attribute.map((filter, i) => {
                                                        return (<span key={i} className='grey px-1 mx-1' >{filter} </span>)
                                                    })}

                                                    {this.props.relation && this.props.relation.map((filter, i) => {
                                                        return (<span key={i} className='grey px-1 mx-1' >{filter} </span>)
                                                    })}
                                                    {
                                                        this.props.form && this.props.form.searchtext && <Chip label={this.props.form.searchtext} size="small" className='ml-2 ' />
                                                    }
                                                    {
                                                        countCountry !== 0 && <span className='grey px-1 mx-1' id="search-text">Country<span className='grey px-1 mx-1' id="search-country">: {country}</span> </span>
                                                    }
                                                </small>
                                            </div>
                                        )
                                    }
                                }
                            </DirectionContext.Consumer>

                        </div>

                        <div className="col-md-3 col-sm-3 col-xs-3 col-xs-3 mb-5">
                            {
                                !this.state.isEmployer &&
                                <Tooltip disableFocusListener title="Refine your search" id='tooltip'>
                                    <Button variant="contained" className='bg-grey shadow-md w-100 mb-3 mt-2 advanceButton' onClick={() => this.showAdvanceSearch()} id="advance-search" style={{ fontSize: 13 }}>
                                        Advanced Search <AddIcon style={{ fontSize: 16, color: 'white' }} />
                                    </Button>
                                </Tooltip>
    }

                            {
                                options !== undefined && options.length > 0 &&
                                <div className="col-md-12 px-3 py-2 bg-grey ">
                                    <Typography
                                        variant="h6" display="block" id="filter-result">
                                        Filter Results
                                    </Typography>

                                </div>
                            }

                            {
                                (showCheckBox.length === 0 || showCheckBox.length === 2) &&
                                <Grid container >
                                    <Grid item xs={6}>
                                        <FormControlLabel
                                            control={<Checkbox checked={this.state.HCP}
                                                onChange={(event) => { this.filterHCPHCO(event) }}
                                                name="HCP" size="small" />}
                                            label={
                                                <Typography
                                                    variant="caption" display="block">
                                                    HCP
                                                </Typography>
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControlLabel
                                            control={<Checkbox checked={this.state.HCO}
                                                onChange={(event) => { this.filterHCPHCO(event) }}
                                                name="HCO" size="small" />}
                                            label={
                                                <Typography
                                                    variant="caption" display="block">
                                                    HCO
                                                </Typography>
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            }
                            {
                                options !== undefined && options.length > 0 &&
                                <DirectionContext.Consumer>
                                    {
                                        (direction)=> {
                                            return (
                                                <div className=" container w-100 ps-0 mt-3" id="filter-result">
                                                    <Autocomplete
                                                        value={this.state.dynamicList}
                                                        multiple={true}
                                                        limitTags={0}
                                                        disableCloseOnSelect
                                                        label="Select attribute"
                                                        className="filter-result"
                                                        key={'filterId'}
                                                        options={sortTranslated(options)}
                                                        onChange={(event, value) => this.addDynamicFilter(value, 'filterId')}
                                                        getOptionLabel={(option) => option.label}
                                                        isOptionEqualToValue={(option, value) => option.name === value.name}
                                                        renderTags={(tagValue, getTagProps) =>
                                                            tagValue.map((option, index) => (
                                                            <Chip
                                                                size='small'
                                                                
                                                                sx={{direction, padding:'3px'}}
                                                                deleteIcon={<Close sx={{margin: '0 !important'}}/>}
                                                                label={<span className='_wg-exclude'>{option.label}</span>}
                                                                {...getTagProps({ index })}
                                                            />
                                                            ))
                                                        }
                                                        id={'filterId'}
                                                        name={'filterId'}
                                                        PaperComponent={({ children }) => (
                                                            <Paper id="filter-result" className="filter-result" >{children}</Paper>
                                                        )}

                                                        renderInput={(params) =>
                                                            <TextField {...params} label="Add Filter" variant="standard" id="add-filter" />}
                                                    />
                                                </div>
                                            )
                                        }
                                    }
                                </DirectionContext.Consumer>

                            }
                            {
                                this.state.dynamicList.length !== 0 &&
                                <div className=" container w-100 ps-0  mt-3">
                                    {
                                        [...this.state.dynamicFilterList].map((filter, key) => {
                                            if (this.state.dynamicList.some((element) => {
                                                return element.id === filter[0]
                                            })) {
                                                return <Filters

                                                    key={key}
                                                    list={filter[1]}
                                                    name={filter[0]}
                                                    label={this.getLabelDynamicFilter(filter[0])}
                                                    onSelect={(value, id) => this.onSelect(value, id)}
                                                    deleteItem={(value) => this.removeDynamicFilter(value)}

                                                />
                                            }
                                            return '';
                                        })
                                    }

                                </div>
                            }




                        </div>



                        {
                            <div className="col-xs-9 col-xxs-9 col-sm-9 col-md-9 ">
                                     <Stack
                                        direction={'row'}
                                        justifyContent={'space-between'}
                                        alignItems={'center'}
                                        padding={"0px 33px 0px 0px"}
                                    >
                                     <Typography
                                        variant="h6" 
                                        display="block" 
                                        id="search-result"
                                    >
                                        {this.state.isEmployer ? 'Employer only Search Results' : 'Search Results'}
                                    </Typography>
                                    <Tooltip disableFocusListener title="Return To Home" id="tooltip">
                                        <IconButton aria-label="delete"
                                            className="float-end  m-0 p-0 text-danger"
                                            onClick={() => this.getBack()}
                                            color="secondary">
                                            <HomeIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                                {((this.state.allItems).length > 0) &&
                                    <div className='mt-1 row pe-6'>
                                        <small className='col-7' id="result-retrived">
                                            Retrieved  {this.state.sessionAllItems.length} of {Storage.getCount()}
                                            {
                                                Storage.getCount() >= CONSTANT.ES_COUNT &&
                                                <Tooltip disableFocusListener title="We found too many results to show them all. Refine your Search." id="tooltip">
                                                    <InfoOutlinedIcon className='ms-1 mb-1' style={{ fontSize: 16 }} />
                                                </Tooltip>
                                            }
                                        </small>
                                        <div className='col-3'>




                                        </div>
                                        <div className='col-1'>


                                            <ToggleButtonGroup orientation="horizontal" value={this.state.view} exclusive onChange={(event, nextView) => this.handelViewChange(event, nextView)}>


                                                <ToggleButton value="list" size='small' className=' border-0' aria-label="list">
                                                   <DirectionContext.Consumer>
                                                        {
                                                            (dir) => (
                                                            <Tooltip disableFocusListener title="List View" id="tooltip">
                                                                <ViewListIcon sx={{transform: dir==='rtl'?'rotate(180deg)':'rotate(0deg)'}}/>
                                                            </Tooltip>
                                                            )
                                                        }
                                                    </DirectionContext.Consumer>
                                                </ToggleButton>
                                                <ToggleButton value="module" size='small' className=' border-0' aria-label="module">

                                                    <Tooltip disableFocusListener title="Tabular View" id="tooltip">
                                                        <ViewModuleIcon />
                                                    </Tooltip>
                                                </ToggleButton>


                                            </ToggleButtonGroup>
                                        </div>

                                    </div>
                                }
                                {this.state.showCheckBox &&
                                    <div className="container d-flex justify-content-center" >
                                        <Alert severity="info" className="w-80 justify-content-center text-center" color="info" id="merge-alert" >
                                            Please select maximum {vendorInfo.noOfprofile} profile for Merge.

                                        </Alert>
                                    </div>
                                }

                                {
                                    this.state.view === 'list' && ((this.state.allItems).length > 0) &&
                                    <>
                                        {!this.state.showCheckBox &&
                                            <List style={{ display: 'flex', flexDirection: 'row', padding: 0 }}>
                                                 <ListItem style={{ maxWidth: 'max-content'}}>
                                                    <ListItemAvatar>
                                                        <Avatar color='primary'><PersonAddAltOutlinedIcon/></Avatar>
                                                    </ListItemAvatar>

                                                    {
                                                        <ListItemText id="search-add-hcp">
                                                        <Link to={{ pathname: '/new/hcp', state: { iqviaSource: false, homePage_Lilly: false, user: this.props.user } }} className='pointer text-decoration-none'>
                                                            Add New HCP
                                                        </Link>
                                                    </ListItemText>                                          
                                                    }                                                               
                                                </ListItem>

                                           
                                                <ListItem style={{ maxWidth: 'max-content', margin:'auto', margin:'auto'}}>
                                                  <ListItemAvatar>
                                                         <Avatar color='primary' ><CorporateFareIcon/><AddCircleIcon sx={{ position: "absolute", color: 'white', bottom: 7, right: 7, backgroundColor: '#bdbdbd', borderRadius: '50%', fontSize:'small'}} /> </Avatar>
                                                   
                                                    </ListItemAvatar>

                                                    {/* {this.props.lillyCountry.length > 0 &&  */}
                                                        <ListItemText id="search-add-hcp">
                                                        <Link to={{pathname :'/new/hco', state: { iqviaSource: false, homePage_Lilly: false, user: this.props.user }}} className='pointer text-decoration-none'>
                                                            Add New HCO
                                                        </Link>
                                                    </ListItemText>
                                                    {/* }      */}
                                                </ListItem>

                                                {this.state?.userData?.isEmployerAccess && <ListItem style={{ width: 'max-content', margin:'auto'}}>
                                                    <ListItemAvatar>
                                                         <Avatar color='primary' ><CorporateFareIcon/><AddCircleIcon sx={{ position: "absolute", color: 'white', bottom: 7, right: 7, backgroundColor: '#bdbdbd', borderRadius: '50%', fontSize:'small'}} /> </Avatar>
                                                    </ListItemAvatar>

                                                    <Link to={{pathname :'/new/employer'}} className='pointer text-decoration-none'>
                                                        Add New Employer
                                                    </Link>
                                                </ListItem>}

                                                {
                                                    !this.state.isEmployer &&
                                                    <ListItem style={{ width: 'max-content', margin:'auto'}}>
                                                        <ListItemAvatar>
                                                            <Avatar color='primary'><Merge /></Avatar>
                                                        </ListItemAvatar>

                                                        <ListItemText id="search-merge">
                                                            <Button className="tableMerge" onClick={() => this.showMergedCheckBox()}>Merge</Button>
                                                        </ListItemText>
                                                    </ListItem>
                                                }

                                                {
                                                    !this.state.isEmployer &&
                                                    <ListItem style={{ width: 'max-content', margin:'auto'}}>
                                                        <ListItemAvatar>
                                                            <Avatar color='primary'><Merge /></Avatar>
                                                        </ListItemAvatar>

                                                        <ListItemText id="search-merge">
                                                            <Button className="tableMerge" onClick={() => this.showMergedCheckBox()}>Merge</Button>
                                                        </ListItemText>
                                                    </ListItem>
                                                }

                                                <ListItem style={{ width: 'max-content', margin:'auto'}}>

                                                    <ListItemAvatar>
                                                        <Avatar color='primary'><SearchIcon /></Avatar>
                                                    </ListItemAvatar>

                                                    <ListItemText id="search-add-hcp">
                                                        <Button className="tableMerge" onClick={() => this.vendorSearch(true)} >
                                                            Vendor Search
                                                        </Button>
                                                    </ListItemText>
                                                </ListItem>


                                            </List>
                                        }

                                        {this.state.showCheckBox &&
                                            <List style={{ display: 'flex', flexDirection: 'row', padding: 0 }}>
                                                <ListItem>

                                                    <ListItemAvatar>
                                                        <Avatar color='primary'><Merge /></Avatar>
                                                    </ListItemAvatar>

                                                    <ListItemText id="search-add-hcp">
                                                        <Button className='tableMerge' onClick={() => this.goToMerge()}>Proceed to Merge</Button >

                                                    </ListItemText>
                                                </ListItem>

                                                <ListItem>

                                                    <ListItemAvatar>
                                                        <Avatar color='primary'><ClearIcon /></Avatar>
                                                    </ListItemAvatar>

                                                    <ListItemText id="search-merge">
                                                        <Button className="tableMerge" onClick={() => this.cancelMerge()}>Cancel</Button>
                                                    </ListItemText>
                                                </ListItem>


                                            </List>
                                        }

                                        <List>
                                            {
                                                this.state.allItems?.map((detail, i) =>
                                                    <ListItem key={detail._id} >
                                                        {this.state.showCheckBox && detail?._source?.CustomerTypeCode?.[0]?.value !== 'Employer' && <Checkbox id="checkbox" checked={this.state.checklist.includes(detail._id)} onChange={(e) => this.getSelectedData(detail, e, detail._id)} />}
                                                        <ListItemAvatar>
                                                            <ProfileIcon
                                                                type={detail._source?.type?.split('/')[2]}
                                                                sx={{width: '40px', height: '40px', marginRight:'5px'}}
                                                            />
                                                        </ListItemAvatar>

                                                        <Link to={'/details/' + detail._id + '/' + detail._source?.type.split('/')[2]} className=" text-decoration-none">
                                                            <ListItemText className="pointer text-decoration-none" onClick={() => this.goToDetails(detail)}
                                                                primary={(detail._source?.label !== undefined && detail._source?.label.length) === 0 ? '<No Label>' : detail._source?.label}
                                                                secondary={<>
                                                                    {detail?._source?.secondaryLabel && detail._source?.secondaryLabel?.length != 0 ? <span className="mb-0">{detail._source?.secondaryLabel}<br /></span> : ''}
                                                                    {detail?._source?.CountryCode && detail._source?.CountryCode?.length != 0 ? <span className="mb-0">{detail._source?.CountryCode[0].value} </span> : ''}



                                                                </>
                                                                }
                                                            />
                                                            <Chip size="small" label={detail._source?.type ? (detail._source?.type?.split('/')[2]) : ''} />
                                                            {detail?._source?.Source != undefined && detail?._source?.Source?.length != 0 ? <Chip className="ml-3 mr-5" size="small" style={{ marginLeft: "10px" }} label={this.sourceChipData(detail._source.Source)} /> : ''}
                                                            {detail?._source?.ClassificationCode != undefined && detail?._source?.ClassificationCode?.length != 0 ? <Chip className="ml-3 mr-5" size="small" style={{ marginLeft: "10px" }} label={this.sourceChipData(detail._source.ClassificationCode)} /> : ''}
                                                            {detail?._source?.CustomerTypeCode != undefined && detail?._source?.CustomerTypeCode?.length != 0 ? <Chip className="ml-3 mr-5" size="small" style={{ marginLeft: "10px" }} label={this.sourceChipData(detail?._source?.CustomerTypeCode)} /> : ''}

                                                        </Link>
                                                        {
                                                            detail?._source?.CustomerTypeCode?.[0]?.value !== 'Employer' && 
                                                            <Tooltip sx={{marginLeft:'auto'}} disableFocusListener title="Merge" id="mergeTooltip">
                                                                <IconButton aria-label="delete "
                                                                    color="secondary" onClick={() => this.showMergedCheckBox()}>
                                                                    <FileDownloadIcon className="text-muted"/>
                                                                </IconButton>
                                                            </Tooltip>
                                                        }
                                                    </ListItem>)
                                            }
                                        </List>
                                    </>
                                }
                                {
                                    this.state.view === 'module' &&


                                    <Paper className="mt-3" >
                                        <>
                                            {!this.state.showCheckBox &&
                                                <div className='row' >
                                                    <div id="search-add-hcp">
                                                        <List className='w-60' style={{ display: 'flex', flexDirection: 'row', padding: 0 }} >
                                                            <ListItem style={{ maxWidth: 'max-content' }}>
                                                                    <ListItemAvatar>
                                                                       <Avatar color='primary'><PersonAddAltOutlinedIcon/></Avatar>
                                                                    </ListItemAvatar>

                                                                    {
                                                                        <ListItemText id="search-add-hcp">
                                                                            <Link to={{ pathname: '/new/hcp', state: { iqviaSource: false, homePage_Lilly: false } }} className='pointer text-decoration-none'>
                                                                                Add New HCP
                                                                            </Link>
                                                                        </ListItemText>
                                                                    }
                                                                </ListItem>
                                                                <ListItem style={{ maxWidth: 'max-content', margin: 'auto' }}>
                                                                    <ListItemAvatar>
                                                                        <Avatar color='primary' ><CorporateFareIcon /><AddCircleIcon sx={{ position: "absolute", color: 'white', bottom: 7, right: 7, backgroundColor: '#bdbdbd', borderRadius: '50%', fontSize: 'small' }} /> </Avatar>
                                                                    </ListItemAvatar>

                                                                    {/* {this.props.lillyCountry.length > 0 && */}
                                                                        <ListItemText id="search-add-hco">
                                                                            <Link to={{ pathname: '/new/hco', state: { iqviaSource: false, homePage_Lilly: false, user: this.props.user } }} className='pointer text-decoration-none'>
                                                                                Add New HCO
                                                                            </Link>
                                                                        </ListItemText>
                                                                    {/* } */}
                                                                </ListItem>
                                                            
                                                            {this.state?.userData?.isEmployerAccess && <ListItem   style={{ width: 'max-content', margin:'auto'}}>
                                                                <ListItemAvatar >
                                                                    <Avatar color='primary' ><CorporateFareIcon /><AddCircleIcon sx={{ position: "absolute", color: 'white', bottom: 7, right: 7, backgroundColor: '#bdbdbd', borderRadius: '50%', fontSize: 'small' }} /> </Avatar>
                                                                </ListItemAvatar>
                                                                <ListItemText id="search-merge">
                                                                    <Button className="tableMerge" onClick={() => {}}>Add New Employer</Button>
                                                                </ListItemText>
                                                            </ListItem>}

                                                            {
                                                                !this.state.isEmployer &&
                                                                    <ListItem   style={{ width: 'max-content', margin:'auto'}}>
                                                                        <ListItemAvatar >
                                                                            <Avatar><Merge /></Avatar>
                                                                        </ListItemAvatar>
                                                                        <ListItemText id="search-merge">
                                                                            <Button className="tableMerge" onClick={() => this.showMergedCheckBox()}>Merge</Button>
                                                                        </ListItemText>
                                                                    </ListItem>
                                                            }

                                                            <ListItem  style={{ width: 'max-content', margin:'auto'}} >

                                                                <ListItemAvatar>
                                                                    <Avatar color='primary'><SearchIcon /></Avatar>
                                                                </ListItemAvatar>

                                                                <ListItemText id="search-add-hcp">
                                                                    <Button className="tableMerge" onClick={() => this.vendorSearch(true)} >
                                                                        Vendor Search
                                                                    </Button>
                                                                </ListItemText>
                                                            </ListItem>

                                                        </List>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.showCheckBox &&
                                                <List style={{ display: 'flex', flexDirection: 'row', padding: 0 }}>
                                                    <ListItem>

                                                        <ListItemAvatar>
                                                            <Avatar color='primary'><Merge /></Avatar>
                                                        </ListItemAvatar>

                                                        <ListItemText id="search-add-hcp">
                                                            <Button className='tableMerge' onClick={() => this.goToMerge()}>Proceed to Merge</Button >

                                                        </ListItemText>
                                                    </ListItem>

                                                    <ListItem>

                                                        <ListItemAvatar>
                                                            <Avatar color='primary'><ClearIcon /></Avatar>
                                                        </ListItemAvatar>

                                                        <ListItemText id="search-merge">
                                                            <Button className="tableMerge" onClick={() => this.cancelMerge()}>Cancel</Button>
                                                        </ListItemText>
                                                    </ListItem>


                                                </List>
                                            }
                                            <TableContainer className='fw-bold'>
                                                <Table stickyHeader aria-label="sticky table">

                                                    <TableHead id="table-heading">
                                                        <TableRow>
                                                            {this.getTableRows().map((column) => (
                                                                <TableCell className=''
                                                                    key={column.id}
                                                                    align={column.align}
                                                                    
                                                                    style={{ minWidth: column.minWidth, background:'#eee' }}
                                                                >
                                                                    <span>{column.label}</span>
                                                                </TableCell>

                                                            ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody id="search-table-data">
                                                        {
                                                            this.state.allItems?.map((row, i) => {

                                                                return (


                                                                    <TableRow hover role="checkbox" key={row._id}>
                                                                        {
                                                                            this.getTableRows().map((column) => {


                                                                                let tableValue = row._source[column.id];
                                                                                if (column.id === 'ReferenceId') {
                                                                                    let key = "primary_" + row._source.type.split('/')[2] + column.id;
                                                                                    tableValue = row._source[key];
                                                                                }
                                                                                if (column.id === 'Specialities') {
                                                                                    tableValue = row._source.PrimarySpeciality;
                                                                                }
                                                                                if (tableValue instanceof Array && tableValue && tableValue.length > 0) {
                                                                                    tableValue = tableValue[0].value;
                                                                                }
                                                                                if (column.id === 'type') {
                                                                                    tableValue = tableValue.split('/')[2];
                                                                                }

                                                                                return (<React.Fragment>

                                                                                    <TableCell key={column.id} align={column.align} onClick={() => this.goToDetails()}>
                                                                                        {column.id == 'label' && this.state.showCheckBox && row?._source?.CustomerTypeCode?.[0]?.value !== 'Employer' &&
                                                                                            <Checkbox checked={this.state.checklist.includes(row._id)} onChange={(e) => this.getSelectedData(row, e, row._id)} />

                                                                                        }
                                                                                        {
                                                                                            column.id === 'label' ?
                                                                                                <Link to={'/details/' + row._id + '/' + row._source?.type.split('/')[2]} className=" text-decoration-none">{tableValue.length === 0 ? '<No Label>' : tableValue}</Link> :
                                                                                                tableValue
                                                                                        }
                                                                                    </TableCell>
                                                                                </React.Fragment>);
                                                                            })}
                                                                    </TableRow>
                                                                );
                                                            })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </>
                                    </Paper>

                                }


                                {


                                    ((this.state.allItems).length > 0) &&
                                    <TablePagination
                                        component="div"
                                        id="pagination"
                                        count={this.state.sessionAllItems.length}
                                        page={this.state.page}
                                        onPageChange={(event, newPage) => this.handleChangePage(event, newPage, this.state.sessionAllItems)}
                                        rowsPerPage={this.state.rowsPerPage}
                                        onRowsPerPageChange={(event) => this.handleChangeRowsPerPage(event, this.state.sessionAllItems)}
                                        rowsPerPageOptions={this.state.rowsArray}
                                    />
                                }

                                {this.state.showCheckBox &&
                                    <div className="d-flex justify-content-center mt-4 mb-3">

                                        <button className="btn btn-secondry border cancel-merge" id="cancel-merge" onClick={() => { this.cancelMerge() }}> Cancel </button>
                                        <button className="btn btn-secondry border proceed-to-merge" id='proceed-to-merge' onClick={() => { this.goToMerge() }}> Proceed to Merge </button>
                                    </div>
                                }


                            </div>
                        }

                    </div>
                }

                {
                    this.state.showWarningPopUp &&
                    <div>

                        <Dialog
                            open={true}
                            aria-labelledby="customized-dialog-title"

                        >
                            <DialogTitle id="dialog-title" >
                                {this.state.popUpMsg.heading}
                            </DialogTitle>
                            <DialogContent dividers id="dialog-content">
                                <Typography gutterBottom>

                                    {this.state.popUpMsg.description}
                                </Typography>

                            </DialogContent>
                            <DialogActions className="_wg-dynamic-text">
                                <Button onClick={() => this.handleWarningPopUp()} autoFocus >
                                    Confirm
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>


                }


            </>

        );
    }
}
export default Result;